module.exports = __webpack_public_path__ + "static/js/readStore.800611d1.chunk.worker.js"